import { ITypedReduxAction } from '../../types/redux/actionType';
import { TChatListSetSucceedPayload } from '../chatList';

export enum EUnreadListActionTypes {
  SetPending = 'chats/unreadList/setPending',
  SetSucceed = 'chats/unreadList/setSucceed',
  SetFailed = 'chats/unreadList/setFailed',
}

export interface IUnreadListRequest {
  // timestamp последнего чата, последней страницы
  timestamp?: number;
}

export type TUnreadListActions =
  | ITypedReduxAction<EUnreadListActionTypes.SetPending, IUnreadListRequest>
  | ITypedReduxAction<EUnreadListActionTypes.SetSucceed, TChatListSetSucceedPayload>
  | ITypedReduxAction<EUnreadListActionTypes.SetFailed, void>;
